'use strict';

angular.module('atex.dam', [ 'ngRoute', 'ngResource', 'emguo.poller', 'ui.bootstrap', 'atex.onecms.service', 'atex.onecms.authentication', 'xeditable',
    'ngTouch', 'atex.onecms.ui', 'atex.onecms.application', 'atex.onecms.ui.widgets', 'ngSanitize', 'ui.select','ui.router','valdr', 'pascalprecht.translate', 'ui.grid','ui.grid.resizeColumns', 'ui.grid.moveColumns', 'ui.grid.selection', 'ui.grid.saveState', 'ui.grid.autoResize','ds.objectDiff',

    function($provide) {
      $provide.decorator('Application', [ '$delegate', function($delegate) {
        /**
         * This is a chance to inject application wide settings.
         */
        $delegate.settings.prefix = 'act';
        return $delegate;
      } ]);

      $provide.decorator('$q', [ '$delegate', function($delegate) {
        $delegate.allSettled = atex.onecms.AngularUtils.allSettled.bind($delegate, $delegate);

        return $delegate;
      } ]);
    }

]);
